import { formatDistanceToNow } from "date-fns";

export const STAGES = ["Lead", "FTD", "KYC", "Funded", "Active Trader", "Retention Risk", "Dormant", "Withdrawal"];

export const STAGE_COLORS = {
  "Lead": "text-sky-400 border-sky-500/40 bg-sky-500/10",
  "FTD": "text-amber-400 border-amber-500/40 bg-amber-500/10",
  "KYC": "text-violet-400 border-violet-500/40 bg-violet-500/10",
  "Funded": "text-cyan-400 border-cyan-500/40 bg-cyan-500/10",
  "Active Trader": "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
  "Retention Risk": "text-orange-400 border-orange-500/40 bg-orange-500/10",
  "Dormant": "text-zinc-400 border-zinc-500/40 bg-zinc-500/10",
  "Withdrawal": "text-red-400 border-red-500/40 bg-red-500/10",
};

export const SLA_COLORS = {
  on_track: "text-emerald-400",
  at_risk: "text-amber-400",
  breached: "text-red-400",
  escalated: "text-red-400",
  closed: "text-zinc-500",
};

export const ESCALATION_LABELS = {
  none: "—",
  level1: "Level 1",
  level2: "Level 2",
};

export const fmtMoney = (v) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

export const timeAgo = (iso) => {
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return "";
  }
};
